import React, { useEffect, useRef, useState } from "react";
import {
  Badge,
  Box,
  Divider,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material";
import Searchbar from "../../../Components/Searchbar/Searchbar";
import plain from "../../../Utils/Images/Plain.png";
import ChatIcon from "@mui/icons-material/Chat";
import userlogo from "../../../Utils/Images/User.png";
import DeleteIcon from "@mui/icons-material/Delete";
import ReplyIcon from "@mui/icons-material/Reply";
import CancelIcon from "@mui/icons-material/Cancel";

import {
  addDoc,
  doc,
  deleteDoc,
  collection,
  query,
  serverTimestamp,
  getDocs,
  orderBy,
  onSnapshot,
  updateDoc,
  getDoc,
} from "firebase/firestore";
import { db } from "../../../Firebase/Firebase";
import { GetUserImge } from "../../../APIs/Function/User/GetUserImage";
import DeleteModal from "../../../Components/Modal/DeleteModal";
import Loader from "../../../Components/Loader/Loader";
import Inside from "./replyChat";

const Chat = () => {
  const [messages, setMessages] = useState([]);
  const [open, setOpen] = useState(false);
  const [modalID, setModalID] = useState("");
  const [dataFromFirebase, setDataFromFirebase] = useState([]);
  const [ActiveUserdata, setActiveUsedata] = useState("");
  const containerRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [UserDetails, setUserDetails] = useState([]);
  const [chatList, setChatList] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [sendLoading, setSendLoading] = useState(false);
  const [replyingTo, setReplyingTo] = useState(null);

  const handleClose = () => {
    setOpen(!open);
  };

  const handleModal = (id) => {
    setModalID(id);
    setOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      const d = [];
      setLoading(true);
      const supportCha = collection(db, "support");

      const chatListUnsubscribe = onSnapshot(
        query(supportCha, orderBy("sendAt", "desc")),
        async (querySnapshot) => {
          const updatedData = [];
          querySnapshot.forEach((a) => {
            updatedData.push({ id: a.id, ...a.data() });
          });

          setDataFromFirebase(updatedData);

          const userDetailsPromises = updatedData.map(async (e) => {
            const res = await handleChatList(e.id);
            return res?.r;
          });

          try {
            const userDetailsData = await Promise.all(userDetailsPromises);
            setChatList(userDetailsData);
            setLoading(false);
          } catch (error) {
            console.error("Error fetching user details:", error);
          }
        }
      );
      return () => {
        chatListUnsubscribe();
      };
    };

    fetchData();
  }, []);

  // Example usage:

  const handleSearch = (e) => {
    if (e && e.target) {
      // Your search logic using event.target.value
      const query = e.target.value;
      const filteredChatList = chatList.filter((item) => {
        return item.full_name.includes(query);
      });
      setSearchData(filteredChatList);
    }
  };

  const handleSendMessage = async () => {
    try {
      setSendLoading(true);
      if (!ActiveUserdata) {
        console.error("No active user selected.");
        return;
      }

      const path = ["support", ActiveUserdata.toString(), "support_chat"];

      if (inputValue.trim() !== "") {
        const docRef = await addDoc(collection(db, ...path), {
          msg: inputValue,
          sendById: 0,
          sendAt: serverTimestamp(),
          last_msg_by: 0,
          last_msg: inputValue,
          msgType: 1,
          unread_count: 1,
          user_id: 0,
          refrenceChatId: replyingTo.id || "",
        });

        const q = doc(db, "support", ActiveUserdata.toString());

        await updateDoc(q, {
          last_msg_by: 2,
          last_msg: inputValue,
          msgType: 1,
          unread_count: 0,
        });

        setInputValue("");
        setReplyingTo("");

        console.log("Document written with ID: ", docRef.id);
      }
    } catch (error) {
      console.error("Error adding document: ", error);
    } finally {
      setSendLoading(false);
    }
  };

  const getUserChatData = async (id) => {
    try {
      if (!id) {
        console.error("Invalid user ID");
        return;
      }

      const chatRef = collection(db, "support", `${id}`, "support_chat");

      const unsubscribe = onSnapshot(
        query(chatRef, orderBy("sendAt", "asc")),
        (querySnapshot) => {
          const updatedChatData = [];
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            const formattedSendAt = data.sendAt
              ? new Date(data.sendAt.toDate()).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : "";

            updatedChatData.push({
              id: doc.id,
              ...data,
              formattedSendAt,
            });
          });

          setMessages(updatedChatData);
        }
      );

      return () => unsubscribe();
    } catch (error) {
      console.error("Error fetching user chat:", error);
    }
  };

  const handleActive = async (e) => {
    console.log("activeuser");
    setActiveUsedata(e.id);
    setReplyingTo("");
    const q = doc(db, "support", String(e.id));
    await updateDoc(q, {
      unread_count: 0,
    });

    await handleUserDetails(e.id);
    getUserChatData(e.id);
  };

  useEffect(() => {
    scrollToBottom();
  }, [ActiveUserdata, messages]);

  const scrollToBottom = () => {
    if (containerRef.current) {
      const chatContainer = containerRef.current;
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  };

  const handleUserDetails = async (id) => {
    try {
      let res = await GetUserImge(id);
      setUserDetails(res.r);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChatList = async (id) => {
    try {
      let res = await GetUserImge(id);
      return res;
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteMessage = async (messageId) => {
    try {
      // await deleteDoc(
      //   doc(db, "support", ActiveUserdata.toString(), "support_chat", messageId)
      // );
      setOpen(false);

      setMessages((prevMessages) =>
        prevMessages.filter((msg) => msg.id !== messageId)
      );
    } catch (error) {
      console.error("Error deleting message:", error);
    }
  };
  function formatTimestampToHHMM(timestamp){
    if (timestamp) {
      const date = new Date(timestamp?.toDate());
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    }
    return "";
  }
  const handleReply = (message) => {
    console.log(message);
    setReplyingTo(message);
  };

  const replymsg = (messageId) => {
    const selectedMessage = messages.find(
      (message) => message.id === messageId
    );

    if (selectedMessage) {
      handleReply(selectedMessage);
    }
  };
  return (
    <>
      <Box>
        {" "}
        {loading ? (
          <Box sx={{ mt: "25%" }}>
            <Loader />
          </Box>
        ) : (
          <Box sx={{ boxSizing: "border-box", p: 2 }}>
            <Box
              sx={{
                display: "flex",
                boxSizing: "border-box",
                gap: "2%",
                height: "95vh",
              }}
            >
              <Box
                sx={{
                  width: "400px",
                  border: "1px solid #E8E8E8",
                  borderRadius: "5px",
                  p: 1,
                  boxSizing: "border-box",
                  height: "100%",
                  overflow: "auto",
                  "&:hover": {
                    "::-webkit-scrollbar": {
                      width: "5px",
                      borderRadius: "10px",
                    },
                    "::-webkit-scrollbar-thumb": {
                      bgcolor: "gray",
                      borderRadius: "10px",
                    },
                  },
                }}
              >
                <Box sx={{ width: "100%", m: "auto" }}>
                  <Searchbar onChange={handleSearch} placeholder={"Search"} />
                </Box>
                <Box>
                  {searchData.length
                    ? searchData.map((e, i) => (
                        <Box
                          key={i}
                          sx={{
                            display: "flex",
                            textAlign: "left",
                            gap: "15px",
                            width: "100%",
                            mt: "15px",
                            p: 1,
                            boxSizing: "border-box",
                            borderRadius: "5px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleActive(e)}
                        >
                          <Box sx={{ width: "50px", height: "50px" }}>
                            <img
                              width={"100%"}
                              height={"100%"}
                              style={{ borderRadius: "50%" }}
                              src={
                                e?.profile_img
                                  ? `https://api-qhealth.equitysofttechnologies.com//upload/profile_img/${e.profile_img}`
                                  : userlogo
                              }
                              alt="img"
                            />
                          </Box>
                          <Box sx={{ width: "80%" }}>
                            <Typography>{e.full_name}</Typography>
                            <Typography
                              noWrap
                              sx={{
                                color: "#A6A6A6",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                              }}
                            >
                              {dataFromFirebase[i].last_msg}
                            </Typography>
                          </Box>
                        </Box>
                      ))
                    : chatList?.map((e, i) => (
                        <Box
                          key={i}
                          sx={{
                            display: "flex",
                            textAlign: "left",
                            gap: "15px",
                            width: "100%",
                            mt: "15px",
                            boxSizing: "border-box",
                            borderRadius: "5px",
                            cursor: "pointer",
                            alignItems: "center",
                            border: "1px solid #e7e7e7",
                            overflow: "hidden",
                            justifyContent: "space-between",
                            p: 1,
                            transition: "transform 0.2s",
                            ":hover": {
                              transform: "scale(1.05)",
                            },
                          }}
                          onClick={() => handleActive(e)}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              textAlign: "left",
                            }}
                          >
                            <Box
                              sx={{
                                width: "50px",
                                height: "50px",
                              }}
                            >
                              <img
                                width={"100%"}
                                height={"100%"}
                                style={{ borderRadius: "50%" }}
                                src={
                                  e?.profile_img
                                    ? `https://api-qhealth.equitysofttechnologies.com//upload/profile_img/${e?.profile_img}`
                                    : userlogo
                                }
                                alt="img"
                              />
                            </Box>
                            <Box
                              sx={{
                                textAlign: "center",
                                display: "flex",
                                flexDirection: "column",
                                textAlign: "left",
                                ml: "10px",
                                maxWidth: "100px",
                                overflow: "hidden",
                              }}
                            >
                              <Typography>{e?.full_name}</Typography>
                              <Typography
                                noWrap
                                sx={{
                                  color: "#A6A6A6",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                }}
                              >
                                {dataFromFirebase[i].last_msg}
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              width: "25%",
                              textAlign: "right",
                              justifyContent: "end",
                              px: 1,
                            }}
                          >
                            <Box
                              sx={{
                                textAlign: "right",
                                display: "flex",
                                flexDirection: "column",
                                gap: "10px",
                              }}
                            >
                              <Badge
                                sx={{ mr: "10px" }}
                                badgeContent={dataFromFirebase[i].unread_count}
                                color="primary"
                              ></Badge>
                              <Box>
                                <Typography
                                  sx={{
                                    color: "#A6A6A6",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    fontSize: "14px",
                                    textAlign: "right",
                                    mt: "5px",
                                  }}
                                >
                                  { dataFromFirebase[i]?.sendAt && formatTimestampToHHMM(
                                    dataFromFirebase[i]?.sendAt
                                  )}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      ))}
                </Box>
              </Box>

              <Box
                sx={{
                  width: "100%",
                  border: "1px solid #E8E8E8",
                  borderRadius: "5px",
                  p: 2,
                  boxSizing: "border-box",
                  position: "relative",
                }}
              >
                {" "}
                {ActiveUserdata ? (
                  <Box
                    sx={{
                      width: "100%",
                      borderBottom: "1px solid #E8E8E8",
                      alignItems: "center",
                      paddingY: "5px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <Box
                        sx={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                        }}
                      >
                        <img
                          style={{ borderRadius: "50%" }}
                          width={"100%"}
                          height={"100%"}
                          src={
                            UserDetails && UserDetails.profile_img
                              ? `https://api-qhealth.equitysofttechnologies.com//upload/profile_img/${UserDetails?.profile_img}`
                              : userlogo
                          }
                          alt="preview"
                        />
                      </Box>
                      <Typography>{UserDetails?.full_name}</Typography>
                    </Box>
                  </Box>
                ) : (
                  ""
                )}
                <Box
                  sx={{
                    height: "75%",
                    overflow: "auto",
                    "&:hover": {
                      "::-webkit-scrollbar": {
                        width: "5px",
                        borderRadius: "10px",
                      },
                      "::-webkit-scrollbar-thumb": {
                        bgcolor: "gray",
                        borderRadius: "10px",
                      },
                    },
                  }}
                  ref={containerRef}
                >
                  {ActiveUserdata ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        boxSizing: "border-box",
                        p: 1,
                      }}
                    >
                      {messages.map((e, i) => (
                        <Box
                          // onClick={() => handleActive(i)}
                          key={`${i}-${e.sendById}`}
                          sx={{
                            borderRadius: "10px",
                            maxWidth: "48%",
                            minWidth: "15%",
                            alignSelf:
                              e.sendById !== 0 ? "flex-start" : "flex-end",
                            bgcolor: e.sendById === 0 ? "#E9E3E3" : "#D8EEFB",
                            borderRadius:
                              e.sendById === 0
                                ? "10px 10px 10px 0"
                                : "10px 10px 0px 10px",
                            p: 1,
                            boxSizing: "border-box",
                            textAlign: "left",
                          }}
                        >
                          <Box>
                            <Box
                              sx={{
                                display: e.refrenceChatId ? "block" : "none",
                                overflow: "hidden",
                              }}
                            >
                              {e.refrenceChatId ? (
                                <Inside
                                  id={e.refrenceChatId}
                                  chatId={ActiveUserdata.toString()}
                                />
                              ) : (
                                ""
                              )}
                              <Divider />
                            </Box>
                            <Box
                              sx={{
                                borderRadius: "10px",
                                boxSizing: "border-box",
                                textAlign: "left",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: "5px",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  position: "relative",
                                }}
                              >
                                <Typography sx={{ wordBreak: "break-word" }}>
                                  {e.msg}
                                </Typography>
                                <IconButton onClick={() => replymsg(e.id)}>
                                  <ReplyIcon />
                                </IconButton>
                                {e.sendById === 0 && (
                                  <IconButton
                                    className="delete-icon"
                                    onClick={() => handleModal(e.id)}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                )}
                              </Box>
                              <Typography
                                sx={{ fontSize: "12px", textAlign: "right" }}
                              >
                                {e.formattedSendAt}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  ) : (
                    <Box sx={{ mt: "25%" }}>
                      <Typography
                        sx={{ fontFamily: "inter", fontSize: "20px" }}
                      >
                        Please Select Chat
                      </Typography>
                      <ChatIcon sx={{ width: "100px", height: "100px" }} />
                    </Box>
                  )}
                </Box>
                <Box>
                  {ActiveUserdata ? (
                    <Box>
                      <Box
                        sx={{
                          display: replyingTo ?  "flex" :"none",
                          justifyContent: "end",
                          // gap: "10px",
                          bgcolor: "#e7e7e7",
                          mt:'-30px',
                          width: "100%",height:'30px',
                          p: 1,
                          ml: "-5px",
                          borderRadius: "5px 5px 0 0",
                        }}
                      >
                        <Typography
                          sx={{
                            maxWidth: "500px",
                            overflow: "hidden",
                          }}
                        >
                          Replying To {replyingTo?.msg}
                        </Typography>
                        <CancelIcon onClick={() => setReplyingTo(false)} />
                      </Box>
                      <Box>
                        <FormControl
                          sx={{
                            m: 1,
                            width: "98%",
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            bgcolor: "#fff",
                            border: replyingTo ? "1px solid #e7e7e7" : "",
                          }}
                          variant="outlined"
                        >
                          <InputLabel
                            sx={{
                              backgroundColor: "#FFF",
                            }}
                            htmlFor="outlined-adornment-password"
                          >
                            Type a Messages
                          </InputLabel>
                          <OutlinedInput
                            sx={{ width: "100%" }}
                            id="outlined-adornment-password"
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  disabled={sendLoading}
                                  aria-label="toggle password visibility"
                                  edge="end"
                                >
                                  <Box
                                    onClick={handleSendMessage}
                                    sx={{
                                      height: "40px",
                                      width: "40px",
                                      borderRadius: "50%",
                                      p: "5px",
                                      boxSizing: "border-box",
                                      backgroundColor: "#FFF",
                                    }}
                                  >
                                    <img
                                      width={"100%"}
                                      height={"100%"}
                                      src={plain}
                                      alt=""
                                    />
                                  </Box>
                                </IconButton>
                              </InputAdornment>
                            }
                            label="Password"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyPress={(e) => {
                              if (e.key === "Enter") {
                                handleSendMessage();
                              }
                            }}
                          />
                        </FormControl>
                      </Box>
                    </Box>
                  ) : (
                    ""
                  )}
                </Box>
              </Box>
            </Box>
            <DeleteModal
              open={open}
              handleDelete={handleDeleteMessage}
              modalID={modalID}
              onClose={handleClose}
            />
          </Box>
        )}
      </Box>
    </>
  );
};

export default Chat;
